import { SET_NETWORK_STATUS } from '../actions/NetworkStatusActions';

const networkStatusReducer = (state = { isOnline: navigator.onLine }, action) => {
  switch (action.type) {
    case SET_NETWORK_STATUS:
      return { isOnline: action.isOnline };

    default:
      return state;
  }
};

export default networkStatusReducer;
